import { Component, HostBinding, Inject, Input } from "@angular/core";

import { FORM_STATE_PROP } from "../../state-props";

import { get as _get } from "lodash";

@Component({
    selector: "common-client-error-box",
    templateUrl: "./client-error-box.component.html",
    styleUrls: ["./client-error-box.component.scss"],
})
export class ClientErrorBoxComponent {
    @HostBinding("class") public classes = "u-flex-grow-1";
    @Input() public stateProp: string;

    constructor( @Inject(FORM_STATE_PROP) public rootProp) { }

    public clientErrors(state) {
        const errors = _get(state, ["value", "errors"]);
        return Object.keys(errors).map((key) => errors[key]).filter((error) => !!error.errorMessage);
    }

    public showErrorBox(state): boolean {
        return this.clientErrors(state).length > 0;
    }
}
